<template>
    <div>
        <div v-if="!innerIsReview">
            <validation-provider v-slot="{errors}" :rules="rules" :name="label || 'This'" v-show="innerShouldShow" :vid="'validate-'+fieldAssignmentId">
                <h3 v-if="directions">{{directions}}</h3>
                <v-autocomplete
                        v-model="innerValue"
                        v-bind="vProps"
                        :items="countries"
                        item-text="name"
                        item-value="iso2"
                        hide-details="auto"
                        @change="fieldChanged"
                >
                    <template v-if="rules.required" #label>
                        <span v-html="innerLabel"></span>
                    </template>
                </v-autocomplete>
            </validation-provider>
        </div>
        <div v-else>
            <type-review
                    v-if="extraProps"
                    :label="label"
                    :directions="directions"
                    :should-show="innerShouldShow"
                    :show-edit-button="extraProps.editButton"
                    :page-number="extraProps.originalPageNumber"
                    @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin'
import rawCountryData from '../countryData'

// make preferred countries show first in list
const preferredCountries = ['US', 'CA']
const sortedCounrtyData = rawCountryData.slice().sort((a, b) => {
  if (preferredCountries.includes(a.iso2)) return -1
  if (preferredCountries.includes(b.iso2)) return 1
  return 0
})

export default {
  name: 'TypeCountry',
  mixins: [formMixin],
  data() {
    return {
      countries: sortedCounrtyData,
    }
  },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
  computed: {
    defaults() {
      return {
        label: this.innerLabel,
        persistentHint: true,
      }
    },
    rules() {
      return (this.enableValidation) ? {
        ...this.validation_settings,
      } : {}
    },
  },
}
</script>
